export const PIDMock = {
  stationType: 'Compressor',
  devices: [
    {
      deviceId: '0517f0dc-88cd-408e-bbb0-f902bb27d215',
      name: 'Air dryer 5 post filter',
      elementIndex: 0,
      onDevices: [],
      toDevices: ['e3043854-f0b4-4717-a7dd-d4957300a92e'],
      isIndependent: false,
      messages: [
        {
          text: 'Device is not a controllable device',
          severity: 'info',
        },
      ],
      lastService: null,
      filterType: null,
      controlMode: 'notControllable',
      connectivity: 'noState',
      deviceType: 'airFilter',
    },
    {
      deviceId: '07d4cb4c-d528-4aa2-b506-28cae1df2561',
      name: 'dryer 5->dryer 5 post filter',
      elementIndex: 0,
      onDevices: [],
      toDevices: ['0517f0dc-88cd-408e-bbb0-f902bb27d215'],
      isIndependent: false,
      messages: [
        {
          text: 'Device is not a controllable device',
          severity: 'info',
        },
      ],
      pipeDiameter: null,
      controlMode: 'notControllable',
      connectivity: 'noState',
      deviceType: 'pipe',
    },
    {
      deviceId: '0c15094f-32df-46f3-91ca-4f6b0c47e296',
      name: 'Flow 3',
      elementIndex: 0,
      onDevices: [],
      toDevices: ['84021198-270d-4c6f-8806-9be693a13c62'],
      isIndependent: false,
      messages: [
        {
          text: 'Device is not a controllable device',
          severity: 'info',
        },
      ],
      pipeDiameter: null,
      flowM3Min: 22.009,
      brand: 'Suto',
      modelDisplayName: 'S402',
      inMaintenance: null,
      model: 'S402',
      deviceControllerName: 'S402',
      controlMode: 'notControllable',
      connectivity: 'connected',
      deviceType: 'flowSensor',
    },
    {
      deviceId: '0c95582e-c25e-4a43-8278-ed39407254ab',
      name: 'Wet tank 1',
      elementIndex: 0,
      onDevices: [],
      toDevices: ['796d0f82-3fbb-40a5-a606-9402febf273e'],
      isIndependent: false,
      messages: [
        {
          text: 'Device is not a controllable device',
          severity: 'info',
        },
      ],
      inMaintenance: null,
      capacity: 1514,
      brand: null,
      modelDisplayName: 'Wet Tank',
      controlMode: 'notControllable',
      connectivity: 'noState',
      deviceType: 'wetAirTank',
    },
    {
      deviceId: '0da0b9ab-d2c9-4b19-b71a-3499ebf16a99',
      name: '#15 - Nirvana -> Air dryer 6 pre filter',
      elementIndex: 0,
      onDevices: [],
      toDevices: ['f6eed1f0-d53d-4a9e-8761-d276aa2826b1'],
      isIndependent: false,
      messages: [
        {
          text: 'Device is not a controllable device',
          severity: 'info',
        },
      ],
      pipeDiameter: null,
      controlMode: 'notControllable',
      connectivity: 'noState',
      deviceType: 'pipe',
    },
    {
      deviceId: '106f56ad-76ce-46ba-b4d8-244e38f763ad',
      name: 'AMB Temp Sensor',
      elementIndex: 0,
      onDevices: [],
      toDevices: [],
      isIndependent: true,
      messages: [
        {
          text: 'Device is not a controllable device',
          severity: 'info',
        },
      ],
      airTemperatureCelsius: null,
      humidityPercentage: null,
      brand: 'STCT',
      modelDisplayName: 'AMB-T/H',
      inMaintenance: null,
      deviceControllerName: 'AMB Temp 1',
      controlMode: 'notControllable',
      connectivity: 'disconnected',
      deviceType: 'airTemperatureSensor',
    },
    {
      deviceId: '165e4671-0298-4262-a2d3-943a06b929b0',
      name: 'Air dryer 2 post filter',
      elementIndex: 0,
      onDevices: [],
      toDevices: ['c2678b88-4e94-4ad9-aaf2-878447a29c07'],
      isIndependent: false,
      messages: [
        {
          text: 'Device is not a controllable device',
          severity: 'info',
        },
      ],
      lastService: null,
      filterType: null,
      controlMode: 'notControllable',
      connectivity: 'noState',
      deviceType: 'airFilter',
    },
    {
      deviceId: '172034f9-030d-4b3f-acf4-7534207b1060',
      name: 'air dryer 1 pre filter-> air dryer 1',
      elementIndex: 0,
      onDevices: [],
      toDevices: ['45b7fc48-a49a-44f4-8261-d65dca3d86ad'],
      isIndependent: false,
      messages: [
        {
          text: 'Device is not a controllable device',
          severity: 'info',
        },
      ],
      pipeDiameter: null,
      controlMode: 'notControllable',
      connectivity: 'noState',
      deviceType: 'pipe',
    },
    {
      deviceId: '17f573dc-1288-45c6-aebc-734f465c864a',
      name: 'air dryer 2 pre filter-> air dryer 2',
      elementIndex: 0,
      onDevices: [],
      toDevices: ['9ec7503f-db5d-4bd6-a907-4e012d371ffd'],
      isIndependent: false,
      messages: [
        {
          text: 'Device is not a controllable device',
          severity: 'info',
        },
      ],
      pipeDiameter: null,
      controlMode: 'notControllable',
      connectivity: 'noState',
      deviceType: 'pipe',
    },
    {
      deviceId: '25089a09-4745-49bd-b427-4214f5d69fcc',
      name: 'dryer 6 post filter->dry tank1',
      elementIndex: 0,
      onDevices: [],
      toDevices: ['6684f5f3-ce0f-4396-b12e-76eb0eec648c'],
      isIndependent: false,
      messages: [
        {
          text: 'Device is not a controllable device',
          severity: 'info',
        },
      ],
      pipeDiameter: null,
      controlMode: 'notControllable',
      connectivity: 'noState',
      deviceType: 'pipe',
    },
    {
      deviceId: '277fb615-09a1-462f-9ce5-1e8bd4ceb834',
      name: 'Air dryer 5',
      elementIndex: 0,
      onDevices: [],
      toDevices: ['07d4cb4c-d528-4aa2-b506-28cae1df2561'],
      isIndependent: false,
      messages: [
        {
          text: 'Device is not a controllable device',
          severity: 'info',
        },
      ],
      tempCelsius: null,
      activity: null,
      dryerExtendedActivity: null,
      pressureBar: null,
      inMaintenance: null,
      brand: null,
      modelDisplayName: 'Refrigerated Dryer',
      controlMode: 'notControllable',
      connectivity: 'noState',
      connectionType: 'n/a',
      deviceType: 'refrigeratedAirDryer',
    },
    {
      deviceId: '2a75131f-14e8-435d-8ed0-9d3665d982b5',
      name: '#15 - Power ',
      elementIndex: 0,
      onDevices: [],
      toDevices: [],
      isIndependent: false,
      messages: [
        {
          text: 'Device is not a controllable device',
          severity: 'info',
        },
      ],
      currentAmp: 88.9,
      powerKw: 62.9,
      brand: 'CCS',
      modelDisplayName: 'WattNode kW',
      inMaintenance: null,
      deviceControllerName: 'WattNode ',
      controlMode: 'notControllable',
      connectivity: 'connected',
      deviceType: 'powerSensor',
    },
    {
      deviceId: '3a5347dc-fbd8-409e-bdb1-014a8e31b084',
      name: 'Air dryer 5 pre filter',
      elementIndex: 0,
      onDevices: [],
      toDevices: ['493f4478-a604-425c-9deb-916b31fe9196'],
      isIndependent: false,
      messages: [
        {
          text: 'Device is not a controllable device',
          severity: 'info',
        },
      ],
      lastService: null,
      filterType: null,
      controlMode: 'notControllable',
      connectivity: 'noState',
      deviceType: 'airFilter',
    },
    {
      deviceId: '3e5a71ee-11ef-4f25-a346-d34eff62ae68',
      name: 'Air dryer 6 post filter',
      elementIndex: 0,
      onDevices: [],
      toDevices: ['25089a09-4745-49bd-b427-4214f5d69fcc'],
      isIndependent: false,
      messages: [
        {
          text: 'Device is not a controllable device',
          severity: 'info',
        },
      ],
      lastService: null,
      filterType: null,
      controlMode: 'notControllable',
      connectivity: 'noState',
      deviceType: 'airFilter',
    },
    {
      deviceId: '436bc2c1-7de7-4a69-9454-fb0924dd4eae',
      name: 'air dryer 2->air dryer 2 post filter',
      elementIndex: 0,
      onDevices: [],
      toDevices: ['165e4671-0298-4262-a2d3-943a06b929b0'],
      isIndependent: false,
      messages: [
        {
          text: 'Device is not a controllable device',
          severity: 'info',
        },
      ],
      pipeDiameter: null,
      controlMode: 'notControllable',
      connectivity: 'noState',
      deviceType: 'pipe',
    },
    {
      deviceId: '45b7fc48-a49a-44f4-8261-d65dca3d86ad',
      name: 'Air dryer 1 ',
      elementIndex: 0,
      onDevices: [],
      toDevices: ['bcce6194-d339-456d-a28b-fef2a0c1d467'],
      isIndependent: false,
      messages: [
        {
          text: 'Device is not a controllable device',
          severity: 'info',
        },
      ],
      tempCelsius: null,
      activity: null,
      dryerExtendedActivity: null,
      pressureBar: null,
      inMaintenance: null,
      brand: null,
      modelDisplayName: 'Refrigerated Dryer',
      controlMode: 'notControllable',
      connectivity: 'noState',
      connectionType: 'n/a',
      deviceType: 'refrigeratedAirDryer',
    },
    {
      deviceId: '493f4478-a604-425c-9deb-916b31fe9196',
      name: 'dryer 5 pre filter->dryer 5',
      elementIndex: 0,
      onDevices: [],
      toDevices: ['277fb615-09a1-462f-9ce5-1e8bd4ceb834'],
      isIndependent: false,
      messages: [
        {
          text: 'Device is not a controllable device',
          severity: 'info',
        },
      ],
      pipeDiameter: null,
      controlMode: 'notControllable',
      connectivity: 'noState',
      deviceType: 'pipe',
    },
    {
      deviceId: '4b12314b-12fa-4449-a176-94dd6ff8dff7',
      name: 'dryer 6->dryer 6 post filter',
      elementIndex: 0,
      onDevices: [],
      toDevices: ['3e5a71ee-11ef-4f25-a346-d34eff62ae68'],
      isIndependent: false,
      messages: [
        {
          text: 'Device is not a controllable device',
          severity: 'info',
        },
      ],
      pipeDiameter: null,
      controlMode: 'notControllable',
      connectivity: 'noState',
      deviceType: 'pipe',
    },
    {
      deviceId: '57096124-2634-4f8e-a0ab-435e897698d0',
      name: 'Air dryer 2 pre filter',
      elementIndex: 0,
      onDevices: [],
      toDevices: ['17f573dc-1288-45c6-aebc-734f465c864a'],
      isIndependent: false,
      messages: [
        {
          text: 'Device is not a controllable device',
          severity: 'info',
        },
      ],
      lastService: null,
      filterType: null,
      controlMode: 'notControllable',
      connectivity: 'noState',
      deviceType: 'airFilter',
    },
    {
      deviceId: '5b90452e-b9e3-4612-a703-088ee28c9143',
      name: 'pressure3->dewpoint3',
      elementIndex: 0,
      onDevices: [],
      toDevices: ['e0699e4b-9aa7-4fc0-bc2c-16e78b502b78'],
      isIndependent: false,
      messages: [
        {
          text: 'Device is not a controllable device',
          severity: 'info',
        },
      ],
      pipeDiameter: null,
      controlMode: 'notControllable',
      connectivity: 'noState',
      deviceType: 'pipe',
    },
    {
      deviceId: '60efeef7-f480-4dca-9edf-3857934e6d35',
      name: 'Pressure 1',
      elementIndex: 0,
      onDevices: [],
      toDevices: ['6ee3f306-eeba-4063-a779-32a801e5794d'],
      isIndependent: false,
      messages: [
        {
          text: 'Device is not a controllable device',
          severity: 'info',
        },
      ],
      pressureBar: 7.268,
      brand: "Xi'an Yunyi",
      modelDisplayName: 'YD-31',
      inMaintenance: null,
      deviceControllerName: 'YD31',
      controlMode: 'notControllable',
      connectivity: 'connected',
      deviceType: 'pressureSensor',
    },
    {
      deviceId: '640ac6c8-75f0-4838-b7ad-f95dbaaf1239',
      name: 'Air dryer 1 pre filter',
      elementIndex: 0,
      onDevices: [],
      toDevices: ['172034f9-030d-4b3f-acf4-7534207b1060'],
      isIndependent: false,
      messages: [
        {
          text: 'Device is not a controllable device',
          severity: 'info',
        },
      ],
      lastService: null,
      filterType: null,
      controlMode: 'notControllable',
      connectivity: 'noState',
      deviceType: 'airFilter',
    },
    {
      deviceId: '6684f5f3-ce0f-4396-b12e-76eb0eec648c',
      name: 'Dry air tank 1',
      elementIndex: 0,
      onDevices: [],
      toDevices: ['fe664593-dc10-4027-8414-e78d2f7874b4'],
      isIndependent: false,
      messages: [
        {
          text: 'Device is not a controllable device',
          severity: 'info',
        },
      ],
      inMaintenance: null,
      capacity: 4012,
      brand: null,
      modelDisplayName: 'Dry Tank',
      controlMode: 'notControllable',
      connectivity: 'noState',
      deviceType: 'dryAirTank',
    },
    {
      deviceId: '6e07bfbe-f599-42af-81c8-7896e1ef568d',
      name: 'Flow 1',
      elementIndex: 0,
      onDevices: [],
      toDevices: ['cdf74fc0-2879-41ec-97a4-0ab37e9c7df9', 'a6644d51-decd-4502-bd4b-d3a74b1da37f'],
      isIndependent: false,
      messages: [
        {
          text: 'Device is not a controllable device',
          severity: 'info',
        },
      ],
      pressureBar: 7.412,
      brand: 'CS',
      modelDisplayName: 'VD 500',
      inMaintenance: null,
      pipeDiameter: 80,
      flowM3Min: 14.342,
      model: 'VD 500',
      deviceControllerName: 'VD 500',
      controlMode: 'notControllable',
      connectivity: 'connected',
      deviceType: 'flowSensor_pressureSensor',
    },
    {
      deviceId: '6ee3f306-eeba-4063-a779-32a801e5794d',
      name: 'pressure1->dewpoint1',
      elementIndex: 0,
      onDevices: [],
      toDevices: ['d6061726-2037-43e7-b12a-e4273e5e87e8'],
      isIndependent: false,
      messages: [
        {
          text: 'Device is not a controllable device',
          severity: 'info',
        },
      ],
      pipeDiameter: null,
      controlMode: 'notControllable',
      connectivity: 'noState',
      deviceType: 'pipe',
    },
    {
      deviceId: '706a96e4-7e8f-4d65-9a7a-bd2bdac1e58b',
      name: 'Power - #5 - R75i-W125',
      elementIndex: 0,
      onDevices: [],
      toDevices: [],
      isIndependent: false,
      messages: [
        {
          text: 'Device is not a controllable device',
          severity: 'info',
        },
      ],
      currentAmp: 0.103,
      powerKw: 0,
      brand: 'CCS',
      modelDisplayName: 'WattNode kW',
      inMaintenance: null,
      deviceControllerName: 'WattNode ',
      controlMode: 'notControllable',
      connectivity: 'connected',
      deviceType: 'powerSensor',
    },
    {
      deviceId: '735ebb5f-0b27-4ded-884e-4b89780295b2',
      name: 'Power - #4 - R110n-W',
      elementIndex: 0,
      onDevices: [],
      toDevices: [],
      isIndependent: false,
      messages: [
        {
          text: 'Device is not a controllable device',
          severity: 'info',
        },
      ],
      currentAmp: 128.482,
      powerKw: 94.388,
      brand: 'CCS',
      modelDisplayName: 'WattNode kW',
      inMaintenance: null,
      deviceControllerName: 'WattNode ',
      controlMode: 'notControllable',
      connectivity: 'connected',
      deviceType: 'powerSensor',
    },
    {
      deviceId: '77c6852b-b932-486b-bb66-bbdc8536ef03',
      name: 'dewpoint3->LP pf',
      elementIndex: 0,
      onDevices: [],
      toDevices: ['95cade69-2c12-4385-91d8-72cf3cd4f8e9'],
      isIndependent: false,
      messages: [
        {
          text: 'Device is not a controllable device',
          severity: 'info',
        },
      ],
      pipeDiameter: null,
      controlMode: 'notControllable',
      connectivity: 'noState',
      deviceType: 'pipe',
    },
    {
      deviceId: '796d0f82-3fbb-40a5-a606-9402febf273e',
      name: 'wet tank1->flow1',
      elementIndex: 0,
      onDevices: [],
      toDevices: ['6e07bfbe-f599-42af-81c8-7896e1ef568d'],
      isIndependent: false,
      messages: [
        {
          text: 'Device is not a controllable device',
          severity: 'info',
        },
      ],
      pipeDiameter: null,
      controlMode: 'notControllable',
      connectivity: 'noState',
      deviceType: 'pipe',
    },
    {
      deviceId: '84021198-270d-4c6f-8806-9be693a13c62',
      name: 'flow3->pressure3',
      elementIndex: 0,
      onDevices: [],
      toDevices: ['b4023b5a-957d-4e19-a617-e3549ee40b63'],
      isIndependent: false,
      messages: [
        {
          text: 'Device is not a controllable device',
          severity: 'info',
        },
      ],
      pipeDiameter: null,
      controlMode: 'notControllable',
      connectivity: 'noState',
      deviceType: 'pipe',
    },
    {
      deviceId: '95cade69-2c12-4385-91d8-72cf3cd4f8e9',
      name: 'LP Production floor',
      elementIndex: 0,
      onDevices: [],
      toDevices: [],
      isIndependent: false,
      messages: [
        {
          text: 'Device is not a controllable device',
          severity: 'info',
        },
      ],
      controlMode: 'notControllable',
      connectivity: 'noState',
      deviceType: 'productionFloor',
    },
    {
      deviceId: '9ec7503f-db5d-4bd6-a907-4e012d371ffd',
      name: 'Air dryer 2',
      elementIndex: 0,
      onDevices: [],
      toDevices: ['436bc2c1-7de7-4a69-9454-fb0924dd4eae'],
      isIndependent: false,
      messages: [
        {
          text: 'Device is not a controllable device',
          severity: 'info',
        },
      ],
      tempCelsius: null,
      activity: null,
      dryerExtendedActivity: null,
      pressureBar: null,
      inMaintenance: null,
      brand: null,
      modelDisplayName: 'Refrigerated Dryer',
      controlMode: 'notControllable',
      connectivity: 'noState',
      connectionType: 'n/a',
      deviceType: 'refrigeratedAirDryer',
    },
    {
      deviceId: 'a6644d51-decd-4502-bd4b-d3a74b1da37f',
      name: 'Flow 1 -> Air dryer 2 pre filter',
      elementIndex: 1,
      onDevices: [],
      toDevices: ['57096124-2634-4f8e-a0ab-435e897698d0'],
      isIndependent: false,
      messages: [
        {
          text: 'Device is not a controllable device',
          severity: 'info',
        },
      ],
      pipeDiameter: null,
      controlMode: 'notControllable',
      connectivity: 'noState',
      deviceType: 'pipe',
    },
    {
      deviceId: 'a817a9ac-aaab-427c-97d4-308260e40bf9',
      name: '#5 - R75i-W125 -> Wet tank 1',
      elementIndex: 0,
      onDevices: [],
      toDevices: ['0c95582e-c25e-4a43-8278-ed39407254ab'],
      isIndependent: false,
      messages: [
        {
          text: 'Device is not a controllable device',
          severity: 'info',
        },
      ],
      pipeDiameter: null,
      controlMode: 'notControllable',
      connectivity: 'noState',
      deviceType: 'pipe',
    },
    {
      deviceId: 'a9f10c26-de07-4486-86c5-38819dd7d1f6',
      name: 'dryer 6 pre filter->dryer 6',
      elementIndex: 0,
      onDevices: [],
      toDevices: ['c3cc8d93-ebbb-42b2-a7fc-d5717a54fe7e'],
      isIndependent: false,
      messages: [
        {
          text: 'Device is not a controllable device',
          severity: 'info',
        },
      ],
      pipeDiameter: null,
      controlMode: 'notControllable',
      connectivity: 'noState',
      deviceType: 'pipe',
    },
    {
      deviceId: 'b4023b5a-957d-4e19-a617-e3549ee40b63',
      name: 'Pressure 3',
      elementIndex: 0,
      onDevices: [],
      toDevices: ['5b90452e-b9e3-4612-a703-088ee28c9143'],
      isIndependent: false,
      messages: [
        {
          text: 'Device is not a controllable device',
          severity: 'info',
        },
      ],
      pressureBar: 7.97,
      brand: 'SUTO',
      modelDisplayName: 'S694 16bar',
      inMaintenance: null,
      deviceControllerName: 'S694 new version',
      controlMode: 'notControllable',
      connectivity: 'connected',
      deviceType: 'pressureSensor',
    },
    {
      deviceId: 'b8acb7fc-6ca1-4ebb-9414-6137a57c863b',
      name: '#14 - R160n-A',
      elementIndex: 2,
      onDevices: [],
      toDevices: ['efe89fce-5820-45d4-9606-eb20fafb5698'],
      isIndependent: false,
      messages: [],
      specificPower: null,
      estimatedSpecificPower: null,
      activity: 'load',
      extendedActivity: 'load',
      remoteMode: null,
      operationMode: null,
      runHours: null,
      loadHours: 59867,
      minimumPressureBar: null,
      maximumPressureBar: 8.412,
      nextServiceHours: null,
      nextServiceName: null,
      oilTemperatureCelsius: 86.111,
      pressureBar: 8.067,
      poweredOn: null,
      inverterSpeedRPM: 1373,
      maxInverterSpeedRPM: 2727,
      estimatedFlowM3Min: null,
      estimatedInverterSpeedRPM: null,
      VSDPressureSetpointTargetBar: 7.998,
      minPressureThreshold: null,
      maxPressureThreshold: null,
      brand: 'Ingersoll Rand',
      modelDisplayName: 'R160 Nirvana',
      compressorNumber: 14,
      model: 'R160 Nirvana',
      hp: 200,
      inMaintenance: false,
      currentAmp: null,
      powerKw: 92,
      deviceControllerName: 'XE 145M R55-R160 VSD',
      controlMode: 'controllable',
      connectivity: 'connected',
      connectionType: 'controller',
      deviceType: 'powerSensor_variableSpeedDrive',
    },
    {
      deviceId: 'bcce6194-d339-456d-a28b-fef2a0c1d467',
      name: 'Air dryer 1 -> Air dryer 1 post filter',
      elementIndex: 0,
      onDevices: [],
      toDevices: ['ec43c612-f5e8-40f8-b5a5-c753ec608114'],
      isIndependent: false,
      messages: [
        {
          text: 'Device is not a controllable device',
          severity: 'info',
        },
      ],
      pipeDiameter: null,
      controlMode: 'notControllable',
      connectivity: 'noState',
      deviceType: 'pipe',
    },
    {
      deviceId: 'c2678b88-4e94-4ad9-aaf2-878447a29c07',
      name: 'air dryer 2 post filter->pressure1',
      elementIndex: 0,
      onDevices: [],
      toDevices: ['60efeef7-f480-4dca-9edf-3857934e6d35'],
      isIndependent: false,
      messages: [
        {
          text: 'Device is not a controllable device',
          severity: 'info',
        },
      ],
      pipeDiameter: null,
      controlMode: 'notControllable',
      connectivity: 'noState',
      deviceType: 'pipe',
    },
    {
      deviceId: 'c3cc8d93-ebbb-42b2-a7fc-d5717a54fe7e',
      name: 'Air dryer 6',
      elementIndex: 0,
      onDevices: [],
      toDevices: ['4b12314b-12fa-4449-a176-94dd6ff8dff7'],
      isIndependent: false,
      messages: [
        {
          text: 'Device is not a controllable device',
          severity: 'info',
        },
      ],
      tempCelsius: null,
      activity: null,
      dryerExtendedActivity: null,
      pressureBar: null,
      inMaintenance: null,
      brand: null,
      modelDisplayName: 'Refrigerated Dryer',
      controlMode: 'notControllable',
      connectivity: 'noState',
      connectionType: 'n/a',
      deviceType: 'refrigeratedAirDryer',
    },
    {
      deviceId: 'cb3bc31d-53a4-4dc0-8796-5e1efdc054e8',
      name: '#5 - R75i-W125',
      elementIndex: 1,
      onDevices: ['706a96e4-7e8f-4d65-9a7a-bd2bdac1e58b'],
      toDevices: ['a817a9ac-aaab-427c-97d4-308260e40bf9'],
      isIndependent: false,
      messages: [],
      specificPower: null,
      estimatedSpecificPower: null,
      activity: 'off',
      extendedActivity: 'standby',
      remoteMode: null,
      operationMode: null,
      runHours: 52572,
      loadHours: 47329,
      minimumPressureBar: 6.895,
      maximumPressureBar: 7.584,
      nextServiceHours: null,
      nextServiceName: null,
      oilTemperatureCelsius: 30.556,
      pressureBar: 7.308,
      poweredOn: '1',
      estimatedFlowM3Min: null,
      minPressureThreshold: null,
      maxPressureThreshold: null,
      brand: 'Ingersoll Rand',
      modelDisplayName: 'R75',
      compressorNumber: 5,
      model: 'R75',
      hp: 100,
      inMaintenance: false,
      deviceControllerName: 'XE - Rotary ',
      controlMode: 'controllable',
      connectivity: 'connected',
      connectionType: 'controller',
      deviceType: 'fixedSpeed',
    },
    {
      deviceId: 'cdf74fc0-2879-41ec-97a4-0ab37e9c7df9',
      name: 'Flow 1 -> Air dryer 1 pre filter',
      elementIndex: 0,
      onDevices: [],
      toDevices: ['640ac6c8-75f0-4838-b7ad-f95dbaaf1239'],
      isIndependent: false,
      messages: [
        {
          text: 'Device is not a controllable device',
          severity: 'info',
        },
      ],
      pipeDiameter: null,
      controlMode: 'notControllable',
      connectivity: 'noState',
      deviceType: 'pipe',
    },
    {
      deviceId: 'd51ef621-742d-4e01-b1e5-e29f01d5eee9',
      name: '#15 - Nirvana',
      elementIndex: 3,
      onDevices: ['2a75131f-14e8-435d-8ed0-9d3665d982b5'],
      toDevices: ['0da0b9ab-d2c9-4b19-b71a-3499ebf16a99'],
      isIndependent: false,
      messages: [],
      specificPower: null,
      estimatedSpecificPower: null,
      activity: 'load',
      extendedActivity: 'load',
      remoteMode: null,
      operationMode: null,
      runHours: 7078,
      loadHours: null,
      minimumPressureBar: null,
      maximumPressureBar: 8.136,
      nextServiceHours: null,
      nextServiceName: null,
      oilTemperatureCelsius: 82.222,
      pressureBar: 7.998,
      poweredOn: null,
      inverterSpeedRPM: 938,
      maxInverterSpeedRPM: 2086,
      estimatedFlowM3Min: null,
      estimatedInverterSpeedRPM: null,
      VSDPressureSetpointTargetBar: 7.791,
      minPressureThreshold: null,
      maxPressureThreshold: null,
      brand: 'Ingersoll Rand',
      modelDisplayName: 'Nirvana - 150H - CC',
      compressorNumber: 15,
      model: 'Nirvana - 150H - CC',
      hp: 150,
      inMaintenance: false,
      deviceControllerName: 'SGNeVSCC-S1-2VS11500',
      controlMode: 'controllable',
      connectivity: 'connected',
      connectionType: 'controller',
      deviceType: 'variableSpeedDrive',
    },
    {
      deviceId: 'd6061726-2037-43e7-b12a-e4273e5e87e8',
      name: 'Dew point 1',
      elementIndex: 0,
      onDevices: [],
      toDevices: ['e43af04f-217f-4d15-9e20-156253feca7e'],
      isIndependent: false,
      messages: [
        {
          text: 'Device is not a controllable device',
          severity: 'info',
        },
      ],
      tempCelsius: null,
      dewpointTemperatureCelsius: 0.837,
      humidityPercentage: null,
      brand: 'Suto',
      modelDisplayName: 'S215 (pDp only)',
      inMaintenance: null,
      deviceControllerName: 'S215 dew point',
      controlMode: 'notControllable',
      connectivity: 'connected',
      deviceType: 'dewpointSensor',
    },
    {
      deviceId: 'e0699e4b-9aa7-4fc0-bc2c-16e78b502b78',
      name: 'Dew point 3',
      elementIndex: 0,
      onDevices: [],
      toDevices: ['77c6852b-b932-486b-bb66-bbdc8536ef03'],
      isIndependent: false,
      messages: [
        {
          text: 'Device is not a controllable device',
          severity: 'info',
        },
      ],
      tempCelsius: null,
      dewpointTemperatureCelsius: 0.077,
      humidityPercentage: null,
      brand: 'Suto',
      modelDisplayName: 'S215 (pDp only)',
      inMaintenance: null,
      deviceControllerName: 'S215 dew point',
      controlMode: 'notControllable',
      connectivity: 'connected',
      deviceType: 'dewpointSensor',
    },
    {
      deviceId: 'e3043854-f0b4-4717-a7dd-d4957300a92e',
      name: 'dryer 5 post filter->dry tank1',
      elementIndex: 0,
      onDevices: [],
      toDevices: ['6684f5f3-ce0f-4396-b12e-76eb0eec648c'],
      isIndependent: false,
      messages: [
        {
          text: 'Device is not a controllable device',
          severity: 'info',
        },
      ],
      pipeDiameter: null,
      controlMode: 'notControllable',
      connectivity: 'noState',
      deviceType: 'pipe',
    },
    {
      deviceId: 'e43af04f-217f-4d15-9e20-156253feca7e',
      name: 'dewpoint1->LP pf',
      elementIndex: 0,
      onDevices: [],
      toDevices: ['95cade69-2c12-4385-91d8-72cf3cd4f8e9'],
      isIndependent: false,
      messages: [
        {
          text: 'Device is not a controllable device',
          severity: 'info',
        },
      ],
      pipeDiameter: null,
      controlMode: 'notControllable',
      connectivity: 'noState',
      deviceType: 'pipe',
    },
    {
      deviceId: 'e4576ad7-a23b-4dea-a71a-4a2e36f46d52',
      name: '#4 - R110n-W -> Wet tank 1',
      elementIndex: 0,
      onDevices: [],
      toDevices: ['0c95582e-c25e-4a43-8278-ed39407254ab'],
      isIndependent: false,
      messages: [
        {
          text: 'Device is not a controllable device',
          severity: 'info',
        },
      ],
      pipeDiameter: null,
      controlMode: 'notControllable',
      connectivity: 'noState',
      deviceType: 'pipe',
    },
    {
      deviceId: 'ec43c612-f5e8-40f8-b5a5-c753ec608114',
      name: 'Air dryer 1 post filter',
      elementIndex: 0,
      onDevices: [],
      toDevices: ['f58654c3-0e92-4918-9a1a-ec401780dc3a'],
      isIndependent: false,
      messages: [
        {
          text: 'Device is not a controllable device',
          severity: 'info',
        },
      ],
      lastService: null,
      filterType: null,
      controlMode: 'notControllable',
      connectivity: 'noState',
      deviceType: 'airFilter',
    },
    {
      deviceId: 'efe89fce-5820-45d4-9606-eb20fafb5698',
      name: '#14 - R160n-A -> Air dryer 5 pre filter',
      elementIndex: 0,
      onDevices: [],
      toDevices: ['3a5347dc-fbd8-409e-bdb1-014a8e31b084'],
      isIndependent: false,
      messages: [
        {
          text: 'Device is not a controllable device',
          severity: 'info',
        },
      ],
      pipeDiameter: null,
      controlMode: 'notControllable',
      connectivity: 'noState',
      deviceType: 'pipe',
    },
    {
      deviceId: 'f58654c3-0e92-4918-9a1a-ec401780dc3a',
      name: 'air dryer 1 post filter->pressure1',
      elementIndex: 0,
      onDevices: [],
      toDevices: ['60efeef7-f480-4dca-9edf-3857934e6d35'],
      isIndependent: false,
      messages: [
        {
          text: 'Device is not a controllable device',
          severity: 'info',
        },
      ],
      pipeDiameter: null,
      controlMode: 'notControllable',
      connectivity: 'noState',
      deviceType: 'pipe',
    },
    {
      deviceId: 'f6eed1f0-d53d-4a9e-8761-d276aa2826b1',
      name: 'Air dryer 6 pre filter',
      elementIndex: 0,
      onDevices: [],
      toDevices: ['a9f10c26-de07-4486-86c5-38819dd7d1f6'],
      isIndependent: false,
      messages: [
        {
          text: 'Device is not a controllable device',
          severity: 'info',
        },
      ],
      lastService: null,
      filterType: null,
      controlMode: 'notControllable',
      connectivity: 'noState',
      deviceType: 'airFilter',
    },
    {
      deviceId: 'f9fe3cff-4c79-45cf-9747-1faa45edfb38',
      name: '#4 - R110n-W',
      elementIndex: 0,
      onDevices: ['735ebb5f-0b27-4ded-884e-4b89780295b2'],
      toDevices: ['e4576ad7-a23b-4dea-a71a-4a2e36f46d52'],
      isIndependent: false,
      messages: [],
      specificPower: null,
      estimatedSpecificPower: null,
      activity: 'load',
      extendedActivity: 'load',
      remoteMode: null,
      operationMode: null,
      runHours: null,
      loadHours: 57936,
      minimumPressureBar: null,
      maximumPressureBar: 7.998,
      nextServiceHours: null,
      nextServiceName: null,
      oilTemperatureCelsius: 86.667,
      pressureBar: 7.446,
      poweredOn: null,
      inverterSpeedRPM: 1452,
      maxInverterSpeedRPM: 2053,
      estimatedFlowM3Min: null,
      estimatedInverterSpeedRPM: null,
      VSDPressureSetpointTargetBar: 7.446,
      minPressureThreshold: null,
      maxPressureThreshold: null,
      brand: 'Ingersoll Rand',
      modelDisplayName: 'R110 Nirvana',
      compressorNumber: 4,
      model: 'R110 Nirvana',
      hp: 150,
      inMaintenance: true,
      deviceControllerName: 'XE 145M R55-R160 VSD',
      controlMode: 'controllable',
      connectivity: 'connected',
      connectionType: 'controller',
      deviceType: 'variableSpeedDrive',
    },
    {
      deviceId: 'fe664593-dc10-4027-8414-e78d2f7874b4',
      name: 'dry tank1->flow3',
      elementIndex: 0,
      onDevices: [],
      toDevices: ['0c15094f-32df-46f3-91ca-4f6b0c47e296'],
      isIndependent: false,
      messages: [
        {
          text: 'Device is not a controllable device',
          severity: 'info',
        },
      ],
      pipeDiameter: null,
      controlMode: 'notControllable',
      connectivity: 'noState',
      deviceType: 'pipe',
    },
  ],
  kpis: {
    flow: {
      expectedRangeLow: 5.66,
      lowerRange: 0,
      expectedRangeHigh: 39.64,
      upperRange: 48.14,
      flowDevices: ['0c15094f-32df-46f3-91ca-4f6b0c47e296', '6e07bfbe-f599-42af-81c8-7896e1ef568d'],
    },
    pressure: {
      targetMinThreshold: 6.89,
      targetMaxThreshold: 8.96,
      lowerRange: 0,
      upperRange: 9.65,
      pressureDevices: ['60efeef7-f480-4dca-9edf-3857934e6d35', 'b4023b5a-957d-4e19-a617-e3549ee40b63'],
    },
    power: {
      lowerRange: 50,
      upperRange: 500,
      powerDevices: [
        '2a75131f-14e8-435d-8ed0-9d3665d982b5',
        '706a96e4-7e8f-4d65-9a7a-bd2bdac1e58b',
        '735ebb5f-0b27-4ded-884e-4b89780295b2',
        'b8acb7fc-6ca1-4ebb-9414-6137a57c863b',
      ],
    },
  },
};
